import "core-js/modules/es.array.push.js";
import { onBeforeUnmount, onMounted, ref } from "vue";
import { eventBus } from "@/main";
import EventCenter from "@/utils/EventCenter";
import common from "@/utils/utils";
import router from "@/router";

// 使用 Composition API 保存弹窗状态，模板会自动解包该 ref。

export default {
  __name: 'PackageLimitDialog',
  setup(__props) {
    const visible = ref(false);
    const openDialog = () => {
      // 同一时间的多个 50003 响应复用当前弹窗，不重复创建遮罩层。
      visible.value = true;
    };
    const closeDialog = () => {
      // 关闭仅改变当前弹窗状态，不干预触发 50003 的页面业务流程。
      visible.value = false;
    };
    const goToSubscribe = () => {
      // 升级套餐前收起全局弹窗，确保新页面不会继续被遮罩层覆盖。
      closeDialog();
      router.push("/team/package/subscribe");
    };
    const goToExpansionPack = () => {
      // 叠加包入口沿用同一收起逻辑，再进入对应的套餐扩展页面。
      closeDialog();
      router.push("/team/package/expansion-pack");
    };
    onMounted(() => {
      // Axios 拦截器不依赖页面实例，通过全局事件通知根节点弹出套餐上限提示。
      eventBus.$on(EventCenter.openPackageLimitDialog, openDialog);
    });
    onBeforeUnmount(() => {
      // 组件销毁时解除监听，避免热更新或重新挂载后重复触发弹窗。
      eventBus.$off(EventCenter.openPackageLimitDialog, openDialog);
    });
    return {
      __sfc: true,
      visible,
      openDialog,
      closeDialog,
      goToSubscribe,
      goToExpansionPack,
      common
    };
  }
};